import axios from 'axios';
import { SERVER_URL } from './constants.service';

export function loginUser(credentials) {
  return axios.post(`${SERVER_URL}/api/AppUsers/login?include=user`, credentials)
    .then(({ data }) => data);
}

export function register(accountDetails) {
  return axios.post(`${SERVER_URL}/api/Agencies/register`, accountDetails)
    .then(({ data }) => data);
}

export function forgotPassword(userEmail) {
  return axios.post(`${SERVER_URL}/api/AppUsers/reset`, userEmail)
    .then(({ response }) => response);
}

export function resetPassword(data) {
	var token  = data.token;
  return axios.post(`${SERVER_URL}/api/AppUsers/reset-password?access_token=${token}`, data)
    .then(({ response }) => response);
}


export default { loginUser, register, register, forgotPassword, resetPassword};



// WEBPACK FOOTER //
// ./src/modules/services/auth.service.js